import { FormControl, Grid, Typography } from '@mui/material';

import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import TextFieldComponent from 'common/components/TextField/TextField';
import { RootState } from 'common/store/AppStore';
import { setSimulationInstitutionValue } from 'common/store/reducer/simulationReducer';

import { IRegulationSummaryInput } from '../api/type-def';

import styles from './RegulationSummaryInput.module.scss';

const RegulationSummaryInput = (props: IRegulationSummaryInput) => {
	const { items } = props;

	const dispatch = useDispatch();

	const institutionValue = useSelector(
		(state: RootState) => state.simulationArena.simulationInstitutionValue,
	);

	const [institution, setInstitution] = useState(institutionValue);

	const onChangeValue = (event: any) => {
		setInstitution(event.target.value.trim());
		dispatch(setSimulationInstitutionValue(event.target.value.trim()));
	};

	useEffect(() => {
		if (items) {
			if (items.institution) {
				setInstitution(items.institution);
				dispatch(setSimulationInstitutionValue(items.institution));
			}
		}
	}, []);

	return (
		<Grid container>
			<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
				<FormControl fullWidth>
					<div>
						<Typography className={styles['label-style']}>
							Institution
						</Typography>
						<TextFieldComponent
							fullWidth
							inputProps={{
								'data-testid': 'institution-name',
							}}
							type="text"
							name="Define the institution name"
							value={institution}
							onChange={(e) => onChangeValue(e)}
							className={styles['dropdown-width']}
							placeholder="Define the institution name"
						/>
					</div>
				</FormControl>
			</Grid>
		</Grid>
	);
};

export default RegulationSummaryInput;
